var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500.2 500.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#018b9d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coloured_icons",
    "data-name": "Coloured icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M426.94,73.22c-97.62-97.63-256-97.63-353.68,0s-97.63,256,0,353.72,256,97.63,353.68,0,97.63-256,0-353.72Zm-11.1,342.72c-90.92,92.23-239.36,93.23-331.58,2.3S-8.86,178.86,82.06,86.73l2.3-2.3C176.58-6.5,324.92-5.5,415.94,86.73c89.92,91.23,89.92,238-.1,329.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M420,112.44a7.88,7.88,0,0,0-13.2,8.6,6.89,6.89,0,0,0,1.1,1.3c70.82,87,57.61,215.07-29.41,285.89a203,203,0,0,1-264-6.5,7.86,7.86,0,0,0-11.51,10.7,8.12,8.12,0,0,0,1,.9c89.73,80.93,228.06,73.73,309-16a218.81,218.81,0,0,0,7-284.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47,250.18C47,137.94,138,47,250.1,47A203,203,0,0,1,385.53,98.73,7.9,7.9,0,0,0,396,87c-90.13-80.53-228.46-72.83-309,17.3a218.71,218.71,0,0,0-6.9,283.6,7.79,7.79,0,0,0,11.1-.1,7.87,7.87,0,0,0,1-9.81A203,203,0,0,1,47,250.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M382.73,171.66A8.54,8.54,0,0,0,376,168l-167.64-7.2a8.71,8.71,0,0,0-.8,17.41l156.24,6.7L333,280.69H196.39L171.68,146.15a8.66,8.66,0,0,0-5.2-6.5L126,123.74a8.7,8.7,0,0,0-6.3,16.21l36,14.1,25.1,136.64a8.6,8.6,0,0,0,8.5,7.11h4.21L184,324.31a7.16,7.16,0,0,0,4.3,9.2,6.92,6.92,0,0,0,2.51.4h6.7a26,26,0,1,0,38.61,0h56.71a26,26,0,1,0,38.61,0h8.1a7.27,7.27,0,0,0,.9-14.51H200.89l7.9-21.7H339.52a8.49,8.49,0,0,0,8.2-6l36.11-112.53a8.59,8.59,0,0,0-1.1-7.5Zm-166,191.26a11.56,11.56,0,1,1,11.4-11.71v.2a11.5,11.5,0,0,1-11.5,11.51h.1Zm95.33,0a11.51,11.51,0,1,1,11.5-11.51A11.51,11.51,0,0,1,312,362.92Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/Retail.3883acf5a98d640d43e74fa4ceaab6ea.svg";
export { ForwardRef as ReactComponent };